package org.ksdfv.thelema.g3d

import org.ksdfv.thelema.anim.Anim
import org.ksdfv.thelema.anim.IAnim
import org.ksdfv.thelema.g3d.cam.Camera
import org.ksdfv.thelema.g3d.cam.ICamera
import org.ksdfv.thelema.g3d.light.DirectionalLight
import org.ksdfv.thelema.g3d.light.ILight
import org.ksdfv.thelema.g3d.light.LightType
import org.ksdfv.thelema.g3d.node.ITransformNode
import org.ksdfv.thelema.g3d.node.Node
import kotlin.native.concurrent.ThreadLocal

/** Provides default constructors for 3d graphics objects. These constructs are used by engine internally. */
@ThreadLocal
object G3D: I3DGraphicsProvider {
    override fun material(): IMaterial = Material()
    override fun scene(): IScene = Scene()
    override fun armature(): IArmature = Armature()
    override fun object3d(): IObject3D = Object3D()
    override fun node(nodeType: Int): ITransformNode = Node()
    override fun light(lightType: Int): ILight = when (lightType) {
        LightType.Directional -> DirectionalLight()
        LightType.Point -> DirectionalLight()
        LightType.Spot -> DirectionalLight()
        else -> throw NotImplementedError()
    }
    override fun camera(): ICamera = Camera()
    override fun anim(): IAnim = Anim()
}
